import Vue from 'vue';
import Vuex from 'vuex';
import { createDirectStore } from 'direct-vuex';
import auth from './auth';
import badges from './badges';
import getStarted from './getStarted';
import memberInfo from './memberInfo';
import orgs from './organizations';
import org from './organization';
import { singlePoint, multiPoint } from './packetCreator';
import usage from './usage';

Vue.use(Vuex);

const {
  store,
  rootActionContext,
  moduleActionContext,
  rootGetterContext,
  moduleGetterContext
} = createDirectStore({
  modules: {
    auth,
    badges,
    getStarted,
    memberInfo,
    orgs,
    org,
    usage,
    singlePoint,
    multiPoint
  }
});

export default store;

export {
  rootActionContext,
  moduleActionContext,
  rootGetterContext,
  moduleGetterContext
};

export type AppStore = typeof store;
declare module 'vuex' {
  interface Store<S> {
    direct: AppStore;
  }
}
